<div copoVirtualScroller [dataId]="dataId" #scroller="copoVirtualScroller"
	(moreDataNeeded)="onMoreDataNeeded($event.index, $event.limit, $event.provideData)"
	class="copo-no-user-select sidenav-content copo-fastlane-block" @routeAnimation cdkScrollable>
	<div class="fastlane-list-title" translate>global.search.fastlane-requests</div>
	<div class="fastlane-grid copo-container">
		<a *ngFor="let fastlane of scroller.list" class="card-block copo-clickable"
			[routerLink]="['/fastlane/prototype/card' ,fastlane.id]" mat-ripple>
			<div class="fastlane-list-card-header">
				<span class="fastlane-list-card-header-title">{{ fastlane.customerRequestName }}</span>
				<span class="fastlane-list-card-header-ton"
					[matTooltip]="fastlane.quantity ? (fastlane.quantity | copoNumber:'weight':'t' ) : UNDERSCORE">{{
					fastlane.requestedQuantity ? (fastlane.requestedQuantity | copoNumber:'weight':'t' ) : UNDERSCORE
					}}</span>
			</div>
			<div class="fastlane-list-card-informations-block">
				<div class="fastlane-list-card-information-block">
					<span class="fastlane-card-label" translate>eoffer.status</span>
					<span class="fastlane-card-value">{{fastlane.prototypeStatusDescription}}</span>
				</div>
				<div class="fastlane-list-card-information-block">
					<span class="fastlane-card-label" translate>dashboard.steelgrade</span>
					<span class="fastlane-card-value" [matTooltip]="fastlane.requestedSteelGrade">{{
						fastlane.requestedSteelGrade }}</span>
				</div>
			</div>
			<div class="fastlane-list-card-informations-block">
				<div class="fastlane-list-card-information-block">
					<span class="fastlane-card-label" translate>application.procurement.supplier.rfqNumber</span>
					<span class="fastlane-card-value" [matTooltip]="fastlane.supplierRfqNumber">{{
						fastlane.supplierRfqNumber }}</span>
				</div>

				<div class="fastlane-list-card-information-block">
					<span class="fastlane-card-label" translate>eoffer.dimension.mm</span>
					<span class="fastlane-card-value" [matTooltip]="fastlane.dimension">{{ getRequestDimention(fastlane) }}</span>
				</div>
				<div class="fastlane-list-card-information-block">
					<span class="fastlane-card-label" translate>order-tracking.form</span>
					<span class="fastlane-card-value">{{fastlane.form}}</span>
				</div>
			</div>
		</a>
		<copo-loading-spinner *ngIf="scroller.loading"></copo-loading-spinner>
		<div translate class="empty-page-text" *ngIf="!scroller.loading && scroller.list.length === 0">
			order-tracking.no.result</div>
	</div>
</div>